import React, { useState } from "react";

export default function AddArchiveItem({ onAddItem, onCancel }) {
    const [newItem, setNewItem] = useState({
        title: '',
        persianTitle: '',
        image: null,
        description: '',
        persianDescription: '',
        yearStart: '',
        yearEnd: ''
    });
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewItem(prev => ({
            ...prev,
            [name]: value
        }));
    };
    
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setNewItem(prev => ({
                ...prev,
                image: file
            }));
        }
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Create new item object with separate year fields
        const item = {
            title: newItem.title,
            persianTitle: newItem.persianTitle,
            image: newItem.image,
            description: newItem.description,
            persianDescription: newItem.persianDescription,
            yearStart: newItem.yearStart,
            yearEnd: newItem.yearEnd,
            documentCount: 0
        };
        
        // Log the payload before sending to backend
        console.log('Archive item payload:', item);
        
        // Call parent callback to add the item
        onAddItem(item);
        
        // Reset form
        setNewItem({
            title: '',
            persianTitle: '',
            image: null,
            description: '',
            persianDescription: '',
            yearStart: '',
            yearEnd: ''
        });
    };
    
    const handleCancel = () => {
        // Reset form
        setNewItem({
            title: '',
            persianTitle: '',
            image: null,
            description: '',
            persianDescription: '',
            yearStart: '',
            yearEnd: ''
        });
        
        // Call parent callback to hide form
        onCancel();
    };

    return (
        <div className="archive__add-form">
            <h3>Add New Archive Item</h3>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="title">Title (English):</label>
                    <input
                        type="text"
                        id="title"
                        name="title"
                        value={newItem.title}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter archive title in English"
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="persianTitle">Title (Persian):</label>
                    <input
                        type="text"
                        id="persianTitle"
                        name="persianTitle"
                        value={newItem.persianTitle}
                        onChange={handleInputChange}
                        required
                        placeholder="عنوان آرشیو را به فارسی وارد کنید"
                        dir="rtl"
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="image">Image:</label>
                    <input
                        type="file"
                        id="image"
                        name="image"
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="description">Description (English):</label>
                    <textarea
                        id="description"
                        name="description"
                        value={newItem.description}
                        onChange={handleInputChange}
                        required
                        rows="4"
                        placeholder="Enter description in English or paste from clipboard"
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="persianDescription">Description (Persian):</label>
                    <textarea
                        id="persianDescription"
                        name="persianDescription"
                        value={newItem.persianDescription}
                        onChange={handleInputChange}
                        required
                        rows="4"
                        placeholder="توضیحات را به فارسی وارد کنید یا از کلیپ بورد بچسبانید"
                        dir="rtl"
                    />
                </div>
                
                <div className="form-group form-group--year-range">
                    <div className="year-input">
                        <label htmlFor="yearStart">Start Year/Period:</label>
                        <input
                            type="text"
                            id="yearStart"
                            name="yearStart"
                            value={newItem.yearStart}
                            onChange={handleInputChange}
                            required
                            placeholder="e.g., 1853, 1850s, circa 1886, 1850 to 1860"
                        />
                    </div>
                    
                    <div className="year-input">
                        <label htmlFor="yearEnd">End Year/Period (optional):</label>
                        <input
                            type="text"
                            id="yearEnd"
                            name="yearEnd"
                            value={newItem.yearEnd}
                            onChange={handleInputChange}
                            placeholder="e.g., 1896, 1890s, circa 1900"
                        />
                    </div>
                </div>
                
                <div className="form-actions">
                    <button 
                        type="button" 
                        className="button button--cancel"
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                    <button 
                        type="submit" 
                        className="button button--submit"
                    >
                        Add Archive Item
                    </button>
                </div>
            </form>
        </div>
    );
} 